import _isNil from "lodash/isNil";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es7.array.includes.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
var secondaryAnalysisFilesLoaded = produce(function (draft, action) {
  var _action$payload = action.payload,
    files = _action$payload.files,
    secondaryAnalysisId = _action$payload.secondaryAnalysisId,
    sublibraries = _action$payload.sublibraries;
  var filesDraft = draft[secondaryAnalysisId].files;
  filesDraft.loading = false;
  if (sublibraries !== undefined) {
    Object.keys(filesDraft.data).forEach(function (id) {
      var _filesDraft$data$id;
      var status = (_filesDraft$data$id = filesDraft.data[id]) === null || _filesDraft$data$id === void 0 || (_filesDraft$data$id = _filesDraft$data$id.upload) === null || _filesDraft$data$id === void 0 || (_filesDraft$data$id = _filesDraft$data$id.status) === null || _filesDraft$data$id === void 0 ? void 0 : _filesDraft$data$id.current;
      if (!['uploading', 'queued'].includes(status)) {
        delete filesDraft.data[id];
      }
    });
    filesDraft.sublibraries = sublibraries;
  }
  files.forEach(function (file) {
    // The upload status of a file deleted mid-upload can arrive without the file
    if (_isNil(file.id)) return;
    filesDraft.data[file.id] = file;
    filesDraft.data[file.id].upload.status = {
      current: file.upload.status,
      loading: false
    };
  });
});
export default secondaryAnalysisFilesLoaded;